"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useSelectProps = exports.formatOption = void 0;
var react_1 = require("react");
// FORMATTING
exports.formatOption = function (option) {
    if (option.label) {
        return option.label;
    }
    else if (react_1.isValidElement(option.item)) {
        // If item can be rendered, then prefer that
        return option.item;
    }
    else {
        // Otherwise fall back to value
        return option.value;
    }
};
exports.useSelectProps = function (props) {
    // Use select configuration
    var initialOptions = props.initialOptions, defaultValue = props.defaultValue, value = props.value, getOptions = props.getOptions, getItemForValue = props.getItemForValue, onChange = props.onChange, searchable = props.searchable, inlineSearch = props.inlineSearch, multiple = props.multiple, valueDelimiter = props.valueDelimiter, optionsDependOn = props.optionsDependOn, componentProps = __rest(props, ["initialOptions", "defaultValue", "value", "getOptions", "getItemForValue", "onChange", "searchable", "inlineSearch", "multiple", "valueDelimiter", "optionsDependOn"]);
    var useSelectConfiguration = {
        initialOptions: initialOptions,
        defaultValue: defaultValue,
        value: value,
        getOptions: getOptions,
        getItemForValue: getItemForValue,
        onChange: onChange,
        searchable: searchable,
        inlineSearch: inlineSearch,
        multiple: multiple,
        valueDelimiter: valueDelimiter,
        optionsDependOn: optionsDependOn,
    };
    // Select component-only props
    var customComponents = componentProps.components, noOptionsText = componentProps.noOptionsText, placeholderText = componentProps.placeholderText, canSelectAll = componentProps.canSelectAll, clearable = componentProps.clearable, hideOptionOnSelection = componentProps.hideOptionOnSelection, selectValueProps = componentProps.selectValueProps, selectionComponentProps = componentProps.selectionComponentProps, interactiveControl = componentProps.interactiveControl, inputProps = __rest(componentProps, ["components", "noOptionsText", "placeholderText", "canSelectAll", "clearable", "hideOptionOnSelection", "selectValueProps", "selectionComponentProps", "interactiveControl"]);
    return {
        useSelectConfiguration: useSelectConfiguration,
        inputProps: inputProps,
        customComponents: customComponents,
    };
};
//# sourceMappingURL=SelectUtils.js.map